import config from "../config";

const url = config.api.orders;

const toLocalTime = (utcStr) => {
  if (!utcStr) return "N/A";
  // Handle "2026-03-11 12:31:38 UTC" format
  const normalized = utcStr.replace(" UTC", "Z").replace(" ", "T");
  const date = new Date(normalized);
  if (isNaN(date)) return utcStr;
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const handleViewDetails = async (
  salesOrder,
  setDetailsLoading,
  setDetailsError,
  setShowDetailsModal,
  setDetailsModalExceptionId,
  setDetailsHtml,
) => {
  setDetailsLoading(true);
  setDetailsError("");
  setShowDetailsModal(true);
  setDetailsModalExceptionId(salesOrder);

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        sales_order: salesOrder,
      }),
    });
    const json = await res.json();
    let html = "";

    if (
      json.postings &&
      Array.isArray(json.postings) &&
      json.postings.length > 0
    ) {
      html = `
        <div class="max-w-full mx-auto p-4 bg-white font-sans">
          <div class="bg-gradient-to-br from-purple-600 to-purple-800 rounded-2xl p-4 mb-6 shadow-lg">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <div class="text-white/80 text-xs font-semibold uppercase tracking-wider mb-2">
                  Credit Memo
                </div>
                <div class="text-white text-xl font-bold">
                  ${json.vbeln_cm || "N/A"}
                </div>
              </div>
              <div>
                <div class="text-white/80 text-xs font-semibold uppercase tracking-wider mb-2">
                  Sales Order
                </div>
                <div class="text-white text-xl font-bold">
                  ${json.sales_order || "N/A"}
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white rounded-2xl overflow-hidden shadow-md">
            <table class="w-full border-collapse">
              <thead>
                <tr class="bg-gradient-to-r from-slate-50 to-slate-100">
                  <th class="px-5 py-4 text-left text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200">
                    Posting ID
                  </th>
                  <th class="px-5 py-4 text-left text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200">
                    Account
                  </th>
                  <th class="px-5 py-4 text-left text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200">
                    Description
                  </th>
                  <th class="px-5 py-4 text-left text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200 whitespace-nowrap">
                    Date
                  </th>
                  <th class="px-5 py-4 text-right text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200">
                    Amount
                  </th>
                  <th class="px-5 py-4 text-center text-xs font-bold text-slate-600 uppercase tracking-wider border-b-2 border-slate-200">
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                ${json.postings
                  .map(
                    (posting, index) => `
                  <tr class="${
                    index % 2 === 0 ? "bg-white" : "bg-slate-50"
                  } hover:bg-slate-100 transition-colors duration-150">
                    <td class="px-5 py-4 border-b border-slate-200">
                      <div class="font-semibold text-slate-900 text-sm">
                        ${posting.posting_id || "N/A"}
                      </div>
                    </td>
                    <td class="px-5 py-4 border-b border-slate-200">
                      <div class="font-semibold text-slate-900 text-sm">
                        ${posting.hkont || "N/A"}
                      </div>
                    </td>
                    <td class="px-5 py-4 border-b border-slate-200 whitespace-nowrap">
                      <div class="text-slate-600 text-sm">
                        ${posting.account_desc || "N/A"}
                      </div>
                    </td>
                    <td class="px-5 py-4 border-b border-slate-200 whitespace-nowrap">
                      <div class="text-slate-600 text-sm">
                        ${posting.budat || "N/A"}
                      </div>
                    </td>
                    <td class="px-5 py-4 text-right border-b border-slate-200">
                      <div class="font-semibold text-slate-900 text-sm whitespace-nowrap">
                        ${posting.waers || ""} ${posting.amount || "0.00"}
                      </div>
                    </td>
                    <td class="px-5 py-4 text-center border-b border-slate-200">
                      <span class="inline-block px-3 py-1.5 rounded-md text-xs font-semibold ${
                        posting.shkzg === "H"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }">
                        ${posting.shkzg === "H" ? "Credit" : "Debit"}
                      </span>
                    </td>
                  </tr>
                `,
                  )
                  .join("")}
              </tbody>
            </table>
          </div>
          <div class="mt-4 px-5 py-4 bg-slate-50 rounded-xl">
            <div class="text-slate-600 text-sm font-medium">Total Postings: <span class="text-slate-900 text-lg font-bold">${
              json.postings.length
            }</span></div>
          </div>
        </div>
      `;
    } else {
      html = `
        <div class="max-w-7xl mx-auto p-6">
          <div class="flex flex-col items-center justify-center py-16 px-4 bg-slate-50 rounded-2xl border-2 border-dashed border-slate-200">
            <svg class="w-16 h-16 text-slate-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            <p class="text-slate-600 text-base font-medium text-center">
              No posting details available for this order.
            </p>
            <p class="text-slate-400 text-sm text-center mt-2">
              Please check back later or contact support if you believe this is an error.
            </p>
          </div>
        </div>
      `;
    }
    setDetailsHtml(html);
  } catch (e) {
    setDetailsError("Failed to fetch details.");
    setDetailsHtml("");
  } finally {
    setDetailsLoading(false);
  }
};
